import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-accounting-tab-label',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span class="accounting-tab-label">
            <i [class]="icon"></i>
            <span>{{ label }}</span>
        </span>
    `,
    styles: [`
        .accounting-tab-label {
            display: inline-flex;
            align-items: center;
            gap: .4rem;
            white-space: nowrap;
        }

        .accounting-tab-label i {
            color: #0f766e;
            font-size: .95rem;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingTabLabelComponent {
    @Input() icon = 'pi pi-circle';
    @Input() label = '';
}
